import React from "react";
import { useLocation } from "react-router-dom";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import EventUpdatePageChild from "./EventUpdatePageChild";

const EventUpdatePage = () => {
  const { state } = useLocation();
  const currentRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <EventUpdatePageChild currentRecord={currentRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventUpdatePage;
